import React from "react";
import { Input, Button, Avatar, Badge } from "antd";
import { SearchOutlined, BellOutlined, UserOutlined } from "@ant-design/icons";
import AddIcon from "@mui/icons-material/Add";
import styled from "@emotion/styled";

const TopBarContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid red;
  padding: 16px 24px;
  background-color: white;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 12px 16px;
  }
`;
//   width: 100%;

const SearchContainer = styled.div`
  flex: 1;
  max-width: 600px;

  .ant-input-affix-wrapper {
    border-radius: 8px;
    height: 40px;
    background-color: #f5f7fb;
    border: none;

    &:hover,
    &:focus {
      background-color: #e5e7eb;
    }
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 16px;

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

const AddButton = styled(Button)`
  width: 48px;
  height: 48px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #14b8a6;
  border: none;
  box-shadow: 0 4px 6px -1px rgba(20, 184, 166, 0.3);

  &:hover {
    background-color: #0d9488;
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
  }
`;

const IconButton = styled(Button)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: #f5f7fb;

  &:hover {
    background-color: #e5e7eb;
  }
`;

const UserAvatar = styled(Avatar)`
  background-color: #8b5cf6;
  cursor: pointer;
`;

const TopBar = () => {
  return (
    <TopBarContainer>
      <SearchContainer>
        <Input
          placeholder="Search Dashboard"
          prefix={<SearchOutlined style={{ color: "#9CA3AF", paddingTop:"4px" }} />}
          bordered={false}
        />
      </SearchContainer>

      <ActionsContainer>
        <AddButton type="primary" icon={<AddIcon style={{ fontSize: 24 }} />} />

        <IconButton type="text">
          <Badge count={3} size="small" offset={[0, 0]}>
            <BellOutlined style={{ fontSize: "20px", color: "#8B5CF6" }} />
          </Badge>
        </IconButton>

        <UserAvatar size={40} icon={<UserOutlined />} />
      </ActionsContainer>
    </TopBarContainer>
  );
};

export default TopBar;
